import Response from '@/shared/types/response';
import ShippingProfile from '@/shared/types/shipping/shippingProfile.type';
import Zone from '@/shared/types/shipping/zones/zone.type';
import chunkArray from '@/shared/utils/chunkArray';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type Args<B> = {
  profileId: string;
  body: B;
  onUnauthorized?: () => void;
  onProgress?: (progress: number) => void;
};

const createMultipleZones = async <B>({
  profileId,
  body,
  onUnauthorized,
  onProgress,
}: Args<B>) => {
  const token = getCookie('auth_token');

  const bodyObject = body as Omit<Zone, 'delivery_state'> & {
    delivery_state: string[];
  };

  const zonesByState = bodyObject.delivery_state.map((state) => ({
    ...bodyObject,
    delivery_state: state,
  })) as Zone[];

  const chunks = chunkArray(zonesByState, 5);

  const responses: Response<ShippingProfile[]>[] = [];

  let finishedRequests = 0;
  const totalRequests = zonesByState.length;

  for (const chunk of chunks) {
    const promises = chunk.map((zone) => {
      return fetcher<Response<ShippingProfile[]>>({
        url: `/shipping/profiles/${profileId}/zones/`,
        method: 'POST',
        token,
        body: zone,
        onUnauthorized,
      })
        .then((response) => {
          finishedRequests++;

          if (onProgress) {
            onProgress((finishedRequests / totalRequests) * 100);
          }

          return response;
        })
        .catch((error) => {
          console.error(
            'Error occurred in function "createMultipleZones" in file "src/shared/api/shipping/zones/createMultipleZones.ts":',
            error,
          );
          return error as Response<ShippingProfile[]>;
        });
    });

    const results = await Promise.all(promises);
    responses.push(...results);
  }

  return responses;
};

export default createMultipleZones;
